// import AOS from "aos";
import {
  getPromoSwiper,
  globalPageSwiper,
} from "./components/allSwiper";
import { getNavigation } from "./components/navigation";
// import { menuTab } from "./components/menuTab";

getNavigation();

/* check mobile */
var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const bodyEl = document.body;
if (isMobile) {
  bodyEl.classList.add("mobile");
} else {
  bodyEl.classList.add("desktop");
}

// const the_animation = document.querySelectorAll('.animation')
const the_animation = document.querySelectorAll('[data-animation="base"]');


const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('scroll-animation')
    }
    else {
      entry.target.classList.remove('scroll-animation')
    }

  })
},
  {
    root: null,
    rootMargin: "40px",
    threshold: [0.1, 0.5]
  });
//
for (let i = 0; i < the_animation.length; i++) {
  const elements = the_animation[i];

  observer.observe(elements);
}
/* scroll pagination & list */
// const tabNavElement = document.getElementById("pills-tabContent");
// if (tabNavElement) {
//   menuTab();
// }

// setTimeout(() => {
//   AOS.init();
// }, 100);

addEventListener('load', function () {
  /* home page */
  const promoSwiper = document.getElementById("promoSwiper");
  if (promoSwiper) {
    getPromoSwiper();
    bodyEl.classList.add("homepage");
  } else {
    bodyEl.classList.add("page");
  }

  /* detail page */
  globalPageSwiper();
})